import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';

const defaultState = () => ({
  usage: {},
});

const meteringModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_USAGE(state, { usage }) {
      state.usage = usage;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET_USAGE({ commit }) {
      return HTTP({
        url: 'billing/usage',
      }).then((response) => {
        commit('SET_USAGE', { usage: response.data.data });
      }).catch(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.fail.fetch', { name: 'usage data' }), icon: 'times', type: 'error' }));
      });
    },
    PURCHASE_CREDITS({}, { quantity, voucherCode }) { // eslint-disable-line no-empty-pattern
      return HTTP({
        method: 'post',
        url: 'billing/credit-payg',
        data: {
          quantity,
          voucher_secret: voucherCode || undefined,
        },
        suppressFormErrors: true,
      }).then(() => {
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('message.success.purchase', { name: i18n.t('companySettings.billing.credits') }), icon: 'check', type: 'success' }));
        return { purchaseSuccess: true };
      }).catch((error) => { // eslint-disable-line arrow-body-style
        return { purchaseError: error };
      });
    },
  },
  getters: {
    usage: state => state.usage,
  },
};

export default meteringModule;
